import { ACTION_CONSTANTS } from 'actions/constants';

export function openLoader(customLoader) {
  return dispatch => {
    return dispatch({
      type: ACTION_CONSTANTS.loader.open,
      payload: { loading: true, customLoader }
    });
  };
}

export function closeLoader(customLoader) {
  return dispatch => {
    return dispatch({
      type: ACTION_CONSTANTS.loader.close,
      payload: { loading: false, customLoader }
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/loader.js